import { FormattedMessage } from 'react-intl';

interface YourDataWhoProps {
  category: string;
}

function YourDataWho({ category }: YourDataWhoProps) {
  return <FormattedMessage id={`offerWizard.yourData.who.${category}`} />;
}

export default YourDataWho;
